/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AdjustPermitRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/AdjustPermit.pb'
import {AdjustPermitResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/AdjustPermit.pb'


export const adjustPermit = (request: AdjustPermitRequest, options?: CashRequestOptions) => post<AdjustPermitRequest, AdjustPermitResponse>("/2.0/cash/adjust-permit", request, {...options, rejectOnError: true })